import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalsService {

    public apiUrl = environment.apiUrl;
    public imgUrl = environment.imgUrl;
    public user = (sessionStorage.activeUser !== undefined) ? JSON.parse(sessionStorage.activeUser) : undefined;
    public organizacion = (sessionStorage.organization !== undefined) ? JSON.parse(sessionStorage.organization) : undefined;

    constructor(public http: HttpClient) {

    }

}
